import React, { ReactNode } from "react";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import { CustomerFeedback } from "@/src/types/Entities/CustomerFeedback";
import { getThirdPartyCustomerRatingPlatform } from "@/src/services/customerFeedbackService";
import { parseIdFromIri } from "@/src/services/utils";

type CustomerRatingPlatformPromptProps = {
  customerFeedback: CustomerFeedback;
  onRatingPlatformClick?: () => void;
  secondaryAction?: ReactNode;
};

export default function CustomerRatingPlatformPrompt({
  customerFeedback,
  onRatingPlatformClick,
  secondaryAction,
}: CustomerRatingPlatformPromptProps) {
  const { ratingPlatform, ratingPlatformLink } = getThirdPartyCustomerRatingPlatform(parseIdFromIri(customerFeedback.case));

  return (
    <>
      <Typography color="primary" variant="h7" sx={{ display: "block" }}>
        Helfen Sie jetzt auch anderen Kunden, sich zu orientieren!
      </Typography>
      <Typography sx={{ margin: "1rem 0" }}>
        Über das Bewertungsportal {ratingPlatform} können Sie die Unterstützung durch Legalbird öffentlich sichtbar darstellen und bewerten.
      </Typography>
      <Typography sx={{ marginBottom: "1rem" }}>Dies dauert nur eine Minute und hilft anderen Rechtsuchenden bei der Auswahl der richtigen Kanzlei.</Typography>
      <Typography sx={{ marginBottom: "2rem" }}>Wir bedanken uns im Voraus und unterstützen Sie in Zukunft jederzeit gerne wieder!</Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: secondaryAction ? 6 : 12 }}>
          <Button
            component={Link}
            fullWidth
            to={ratingPlatformLink}
            variant="contained"
            target="_blank"
            onClick={onRatingPlatformClick}
            sx={{ marginBottom: "1rem", textAlign: "center" }}
          >
            Auf {ratingPlatform} bewerten
          </Button>
        </Grid>
        {secondaryAction && <Grid size={{ xs: 12, md: 6 }}>{secondaryAction}</Grid>}
      </Grid>
    </>
  );
}
